export default "__VITE_ASSET__CKsp3DBs__"